// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../common/Components/menu/MenuV5.bs.js");
let Numeral = require("../../utils/Numeral.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let IconButton = require("../../reason/common/IconButton.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Types__Common = require("../../reason/common/types/Types__Common.bs.js");
let Belt_SortArray = require("@rescript/runtime/lib/js/Belt_SortArray.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Primitive_string = require("@rescript/runtime/lib/js/Primitive_string.js");
let TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationSettingsUtils = require("./NotificationSettingsUtils.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let NotificationSettingsComponents_group_graphql = require("../../__generated__/NotificationSettingsComponents_group_graphql.bs.js");
let NotificationSettingsComponents_byType_graphql = require("../../__generated__/NotificationSettingsComponents_byType_graphql.bs.js");
let NotificationSettingsEntitySettingConfirmationModal = require("./NotificationSettingsEntitySettingConfirmationModal.bs.js");
let NotificationSettingsComponentsAreaGroupItem_chapter_graphql = require("../../__generated__/NotificationSettingsComponentsAreaGroupItem_chapter_graphql.bs.js");
let NotificationSettingsComponentsPreferenceSummary_chapter_graphql = require("../../__generated__/NotificationSettingsComponentsPreferenceSummary_chapter_graphql.bs.js");

function NotificationSettingsComponents$UpgradeToProDialog(props) {
  let onClose = props.onClose;
  return JsxRuntime.jsx(ConfirmDialog.make, {
    title: "This is a TAN Pro feature",
    ariaLabel: "This is a TAN Pro feature",
    body: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("p", {
        children: "Custom filters for emails is a TAN Pro feature. By upgrading to TAN Pro you get fine-grained control over which emails you want to receive, including by price range, areas, MLS status and more.",
        className: "leading-6"
      }),
      className: "pb-2"
    }),
    isOpen: props.isOpen,
    onCancel: onClose,
    cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => onClose(),
      children: "Cancel"
    }),
    confirmButton: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
      href: "/subscribe",
      children: "Upgrade to Pro"
    })
  });
}

let UpgradeToProDialog = {
  make: NotificationSettingsComponents$UpgradeToProDialog
};

function settingToString(p) {
  switch (p) {
    case "CHAPTER_DEFAULT" :
      return "All broadcasts in my chapter";
    case "CUSTOM" :
      return "Those that match custom filters";
    case "MATCH_ONLY" :
      return "Matches only";
  }
}

function NotificationSettingsComponents$SettingsSelector(props) {
  let onChange = props.onChange;
  let value = props.value;
  let disabled = props.disabled;
  let settings = [
    "CHAPTER_DEFAULT",
    "CUSTOM",
    "MATCH_ONLY"
  ];
  return JsxRuntime.jsx(MenuV5.Menu.make, {
    button: JsxRuntime.jsx(ButtonsV5.Button.make, {
      className: "!font-normal !normal-case !py-2",
      children: JsxRuntime.jsxs("div", {
        children: [
          settingToString(value),
          JsxRuntime.jsx(IconV5.make, {
            icon: "arrow-down",
            size: 14,
            className: "text-gray-500"
          })
        ],
        className: "flex items-center justify-between gap-4 "
      })
    }),
    children: settings.map(setting => JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => onChange(setting),
      isDisabled: disabled || setting === value,
      children: settingToString(setting)
    }, setting))
  });
}

let SettingsSelector = {
  settingToString: settingToString,
  make: NotificationSettingsComponents$SettingsSelector
};

function NotificationSettingsComponents$PreferenceSelectorForm(props) {
  let onPressEdit = props.onPressEdit;
  let __renderSummary = props.renderSummary;
  let onChange = props.onChange;
  let value = props.value;
  let disabled = props.disabled;
  let renderSummary = __renderSummary !== undefined ? __renderSummary : null;
  let match = React.useState(() => false);
  let setConfirmMatchOnly = match[1];
  let tmp;
  switch (value) {
    case "CUSTOM" :
      tmp = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => onPressEdit(),
        disabled: disabled,
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(IconV5.make, {
              icon: "pencil"
            }),
            JsxRuntime.jsx("span", {
              children: "Edit filters",
              className: "text-base font-normal capitalize"
            })
          ],
          className: "flex flex-row space-x-2 py-0.5"
        })
      });
      break;
    case "CHAPTER_DEFAULT" :
    case "MATCH_ONLY" :
      tmp = null;
      break;
  }
  let tmp$1;
  switch (props.entityType) {
    case "BUYER_NEED" :
      tmp$1 = "BuyerNeedOnlyMatches";
      break;
    case "FOR_SALE_PROPERTY" :
      tmp$1 = "PropertyOnlyMatches";
      break;
    case "RENTAL_NEED" :
      tmp$1 = "RentalNeedOnlyMatches";
      break;
    case "RENTAL_PROPERTY" :
      tmp$1 = "RentalPropertyOnlyMatches";
      break;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
        children: props.title
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: props.text,
          className: "leading-relaxed"
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(NotificationSettingsComponents$SettingsSelector, {
            disabled: disabled,
            value: value,
            onChange: v => {
              switch (v) {
                case "CHAPTER_DEFAULT" :
                case "CUSTOM" :
                  break;
                case "MATCH_ONLY" :
                  return setConfirmMatchOnly(param => true);
              }
              setConfirmMatchOnly(param => false);
              onChange(v);
            }
          }),
          tmp
        ],
        className: "flex flex-row items-center gap-4 mt-4 flex-wrap"
      }),
      renderSummary,
      JsxRuntime.jsx(NotificationSettingsEntitySettingConfirmationModal.make, {
        isOpen: match[0],
        onConfirm: () => {
          onChange("MATCH_ONLY");
          setConfirmMatchOnly(param => false);
        },
        onCancel: () => setConfirmMatchOnly(param => false),
        confirmationType: tmp$1
      })
    ],
    className: "mt-7"
  });
}

let PreferenceSelectorForm = {
  make: NotificationSettingsComponents$PreferenceSelectorForm
};

let matchableEntityType_decode = NotificationSettingsComponents_group_graphql.Utils.matchableEntityType_decode;

let convertFragment = NotificationSettingsComponents_group_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponents_group_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponents_group_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsComponents_group_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponents_group_graphql.node, convertFragment, fRef);
}

let GroupFragment_matchableEntityType_fromString = NotificationSettingsComponents_group_graphql.Utils.matchableEntityType_fromString;

let GroupFragment = {
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: GroupFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = NotificationSettingsComponents_byType_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponents_byType_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponents_byType_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsComponents_byType_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponents_byType_graphql.node, convertFragment$1, fRef);
}

let ByTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = NotificationSettingsComponentsAreaGroupItem_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let bullet = '\u2022';

function NotificationSettingsComponents$AreaGroupItem$AreaItem(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: bullet
      }),
      JsxRuntime.jsx("div", {
        children: props.children
      })
    ],
    className: "flex flex-row items-center space-x-2 pl-0.5 mt-2"
  });
}

let AreaItem = {
  bullet: bullet,
  make: NotificationSettingsComponents$AreaGroupItem$AreaItem
};

function NotificationSettingsComponents$AreaGroupItem(props) {
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsComponentsAreaGroupItem_chapter_graphql.node, convertFragment$2, props.chapter);
  let areaGroup = RescriptRelay_Fragment.useFragment(NotificationSettingsComponents_group_graphql.node, convertFragment, props.areaGroup);
  let byType = RescriptRelay_Fragment.useFragment(NotificationSettingsComponents_byType_graphql.node, convertFragment$1, areaGroup.fragmentRefs);
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  let isOpen = match[0];
  let chapterName = chapter.displayName;
  let nTypes = NotificationSettingsUtils.notificationTypesString(Stdlib_Array.filterMap(Stdlib_Option.getOr(areaGroup.usedFor, []), t => matchableEntityType_decode(t)));
  let tmp;
  switch (byType.__typename) {
    case "ChapterAreaGroup" :
      tmp = chapterName + ` chapter areas`;
      break;
    case "UserAreaGroup" :
      tmp = `Custom area group for ` + nTypes;
      break;
    case "__unselected" :
      tmp = UnselectedUnionMemberError.raise(`Unselected area group type: ` + byType._0);
      break;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(IconV5.make, {
              icon: isOpen ? "arrow-down" : "arrow-right",
              size: 12
            }),
            JsxRuntime.jsx("div", {
              children: tmp
            })
          ],
          className: "flex flex-row items-center space-x-2"
        }),
        className: "hover:cursor-pointer mt-2",
        onClick: param => setIsOpen(v => !v)
      }),
      isOpen ? JsxRuntime.jsx("div", {
          children: Belt_SortArray.stableSortBy(Stdlib_Array.keepSome(Stdlib_Option.getOr(areaGroup.areas, [])), (a1, a2) => Primitive_string.compare(a1.label, a2.label) | 0).map(param => JsxRuntime.jsx(NotificationSettingsComponents$AreaGroupItem$AreaItem, {
            children: param.label
          }, param.id)),
          className: "ml-4"
        }) : null
    ]
  });
}

let AreaGroupItem = {
  GroupFragment: GroupFragment,
  ByTypeFragment: ByTypeFragment,
  ChapterFragment: ChapterFragment,
  AreaItem: AreaItem,
  make: NotificationSettingsComponents$AreaGroupItem
};

let convertFragment$3 = NotificationSettingsComponentsPreferenceSummary_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, fRef);
}

let ChapterFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

let ndash = '\u2013';

function NotificationSettingsComponents$PreferenceSummary$Item(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: ndash
      }),
      JsxRuntime.jsx("div", {
        children: props.children
      })
    ],
    className: "flex flex-row space-x-2 items-center pl-0.5 mt-2"
  });
}

let Item = {
  ndash: ndash,
  make: NotificationSettingsComponents$PreferenceSummary$Item
};

function NotificationSettingsComponents$PreferenceSummary(props) {
  let mlsStatus = props.mlsStatus;
  let propertyTypes = props.propertyTypes;
  let maxPrice = props.maxPrice;
  let minPrice = props.minPrice;
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsComponentsPreferenceSummary_chapter_graphql.node, convertFragment$3, props.chapter);
  let propertyTypes$1 = props.tanType === "Rental" ? propertyTypes.filter(x => {
      switch (x) {
        case "LOT" :
        case "MULTI_UNIT" :
          return false;
        case "CONDO" :
        case "SINGLE_FAMILY" :
          return true;
      }
    }) : propertyTypes;
  let priceText = minPrice !== undefined ? (
      maxPrice !== undefined ? "From " + (Numeral.formatPrice(minPrice) + (" to " + Numeral.formatPrice(maxPrice))) : "From " + Numeral.formatPrice(minPrice)
    ) : (
      maxPrice !== undefined ? "Up to " + Numeral.formatPrice(maxPrice) : undefined
    );
  let mlsStatusText = mlsStatus !== undefined && mlsStatus !== "ANY" ? "Not active on the MLS" : undefined;
  let tmp;
  if (propertyTypes$1.length !== 0) {
    let propertyTypesText = Utils.$$Array.join(", ", " and ", propertyTypes$1.map(v => Types__Common.PropertyType.toDisplayString(v))) + " properties";
    tmp = JsxRuntime.jsx(NotificationSettingsComponents$PreferenceSummary$Item, {
      children: propertyTypesText
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      tmp,
      Stdlib_Option.getOr(Stdlib_Option.map(priceText, t => JsxRuntime.jsx(NotificationSettingsComponents$PreferenceSummary$Item, {
        children: t
      })), null),
      Stdlib_Option.getOr(Stdlib_Option.map(mlsStatusText, t => JsxRuntime.jsx(NotificationSettingsComponents$PreferenceSummary$Item, {
        children: t
      })), null),
      JsxRuntime.jsx(NotificationSettingsComponents$AreaGroupItem, {
        areaGroup: props.areaGroup,
        chapter: chapter.fragmentRefs
      })
    ],
    className: "p-2"
  });
}

let PreferenceSummary = {
  ChapterFragment: ChapterFragment$1,
  Item: Item,
  make: NotificationSettingsComponents$PreferenceSummary
};

function areaTypeLabel(x) {
  switch (x) {
    case "BLOCK_GROUP" :
      return "Block Groups";
    case "CENSUS_PLACE" :
    case "CITY" :
      return "Cities";
    case "COUNTY" :
      return "Counties";
    case "NEIGHBORHOOD" :
      return "Neighborhoods";
    case "SCHOOL" :
      return "Schools";
    case "SCHOOL_DISTRICT" :
      return "School Districts";
    case "STATE" :
      return "States";
    case "TOWNSHIP" :
      return "Townships";
    case "ZIP_CODE" :
      return "Zip Codes";
  }
}

function NotificationSettingsComponents$AreaTypesList(props) {
  let __style = props.style;
  let __showCount = props.showCount;
  let onRemoveArea = props.onRemoveArea;
  let areaType = props.areaType;
  let areas = props.areas;
  let showCount = __showCount !== undefined ? __showCount : true;
  let style = __style !== undefined ? __style : "Striped";
  let tmp;
  tmp = style === "Striped" ? "border-b" : "";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("span", {
        children: areaTypeLabel(areaType),
        className: "text-gray-800 font-semibold"
      }),
      showCount ? ` (` + areas.length.toString() + `)` : null,
      JsxRuntime.jsx("ul", {
        children: areas.map(area => {
          let tmp;
          tmp = style === "Striped" ? "border-t py-2 even:bg-gray-50 odd:bg-white" : "";
          return JsxRuntime.jsxs("li", {
            children: [
              JsxRuntime.jsx("div", {
                children: area.label
              }),
              onRemoveArea !== undefined ? JsxRuntime.jsx(IconButton.make, {
                  icon: "cancel",
                  onPress: () => onRemoveArea(area.id),
                  title: area.label
                }) : null
            ],
            className: TailwindMerge.twMerge([
              "text-base font-normal pl-3 flex items-center justify-between",
              tmp
            ])
          }, area.id);
        }),
        className: TailwindMerge.twMerge([
          "pt-1 list-none",
          tmp
        ])
      })
    ]
  }, areaType);
}

let AreaTypesList = {
  areaTypeLabel: areaTypeLabel,
  make: NotificationSettingsComponents$AreaTypesList
};

exports.UpgradeToProDialog = UpgradeToProDialog;
exports.SettingsSelector = SettingsSelector;
exports.PreferenceSelectorForm = PreferenceSelectorForm;
exports.AreaGroupItem = AreaGroupItem;
exports.PreferenceSummary = PreferenceSummary;
exports.AreaTypesList = AreaTypesList;
/* Utils Not a pure module */
